export const filterPage = {
  save(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },

  remove(key) {
    localStorage.removeItem(key)
  },

  get(key, isObj) {
    if (isObj) {
      return JSON.parse(localStorage.getItem(key))
    } else {
      return localStorage.getItem(key)
    }
  }
}
